import { Cta } from "../components/Cta";
import { Section } from "../components/Section";
import { COVERAGE, FOUNDER, PURPOSE, WHAT_YOU_GET } from "../content/about";
import { usePageMeta } from "../lib/usePageMeta";
import styles from "./About.module.css";

/**
 * The About page.
 *
 * The landing page's "The Idea" band answers "what is this" in three
 * sentences, which is the right length for someone still deciding whether to
 * scroll. This page is for the reader who kept going: why the product exists,
 * what an answer actually contains, and who built it.
 *
 * (This note used to say "no `number=` props", back when `Eyebrow` and
 * `Section` could carry a zero-padded section number. Nothing anywhere does
 * now — the prop is gone; see `components/Eyebrow.tsx`.)
 *
 * `level={1}` on the first Section only: most routes are a single Section, so
 * the default of 2 would leave this page with four h2s and no h1. `heroScroll`
 * is opt-in and sanctioned for information pages; it belongs on the first band
 * because the hook reads window.scrollY, which is only meaningful for a page's
 * first element.
 */
export function About() {
  usePageMeta("about");

  return (
    <>
      <Section
        id="purpose"
        eyebrow={PURPOSE.eyebrow}
        heading={PURPOSE.heading}
        level={1}
        tone="ink"
        heroScroll
      >
        <div className={styles.prose}>
          {PURPOSE.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section
        id="what-you-get"
        eyebrow={WHAT_YOU_GET.eyebrow}
        heading={WHAT_YOU_GET.heading}
        tone="deep"
      >
        <div className={styles.prose}>
          {WHAT_YOU_GET.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section id="founder" eyebrow={FOUNDER.eyebrow} heading={FOUNDER.heading} tone="ink">
        <div className={styles.prose}>
          {FOUNDER.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section id="coverage" eyebrow={COVERAGE.eyebrow} heading={COVERAGE.heading} tone="deep">
        <div className={styles.coverage}>
          <Cta to="/pricing">{COVERAGE.cta}</Cta>
        </div>
      </Section>
    </>
  );
}
